exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-control{width:200px;display:flex;flex-direction:column;color:var(--fts-text)}.font-control .font-sizes,.font-control .font-weights{display:flex;justify-content:space-between;text-align:center}.font-control .font-sizes>div,.font-control .font-weights>div{flex:1;padding:4px 8px;border-radius:4px;cursor:pointer}.font-control .font-sizes>div:hover,.font-control .font-weights>div:hover{background-color:#f0f0f0}.font-control .font-sizes>div.selected,.font-control .font-weights>div.selected{color:var(--fts-primary)}.font-control .divider{height:1px;background-color:var(--fts-border);margin:4px}", ""]);

// exports
